<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <form v-else v-scroll-to-error @submit.prevent="submitForm">
    <v-layout class="workshop-update-container">
      <v-flex xs12 sm10 md8 class="form-container">
        <v-layout wrap>
          <v-flex xs12>
            <div class="screen-title mb-32">
              <span>Update Workshop</span>
            </div>
            <workshop-form
              :vs="$v"
              :initial-values="form"
              :halls="halls"
              :event="event"
              @values="form = $event"
            />
            <main-button text="Update" depressed @click="$emit('submit')" />
            <main-button
              text="Delete"
              color="error"
              flat
              @click.prevent="showDeleteDialog = true"
            />
            <main-button text="Cancel" flat @click.prevent="goBack" />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 class="workshop-details">
        <workshop-details :event-id="eventId" :workshop="workshop" />
      </v-flex>
      <delete-dialog
        :content="`Are you sure you want to delete this workshop? This operation cannot be undone.`"
        :on-delete="() => deleteWorkshop()"
        :show.sync="showDeleteDialog"
        title="Remove workshop"
      />
    </v-layout>
  </form>
</template>

<script>
import { GET_EVENT_WORKSHOP_AND_HALLS } from '../../graphql/workshop.graphql.js'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import WorkshopForm from './workshop-form.vue'
import WorkshopDetails from './workshop-details.vue'
import MainButton from './../shared/main-button'
import Spinner from './../shared/spinner'
import { deleteWorkshop, updateWorkshop } from './../../http'
import { required, requiredIf, minValue } from 'vuelidate/lib/validators'
import { date, minDate, maxDate, minValueIf } from './../../validators'
import { submitGuard } from './../../utils'

export default {
  name: 'update-workshop-container',
  components: {
    WorkshopForm,
    WorkshopDetails,
    MainButton,
    Spinner,
    DeleteDialog,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
    workshopId: {
      default: null,
      type: String,
    },
  },
  validations() {
    const component = this
    const event = this.event

    return {
      form: {
        name: { required },
        from: {
          required,
          date,
          minDate: minDate(() => new Date(event.from)),
          maxDate: maxDate(() => component.form.to || new Date(event.to)),
        },
        to: {
          required,
          date,
          minDate: minDate(() => component.form.from || new Date(event.from)),
          maxDate: maxDate(() => new Date(event.to)),
        },
        attendanceLimit: {
          required: requiredIf(values => !values.unlimitedAttendance),
          minValue: minValueIf(
            component.attending,
            () => component.form.unlimitedAttendance || false,
          ),
        },
      },
    }
  },
  data: () => ({
    showDeleteDialog: false,
    workshop: {},
    form: { lecturers: [] },
    attending: 0,
    halls: [],
  }),
  apollo: {
    getEventWorkshop: {
      query: GET_EVENT_WORKSHOP_AND_HALLS,
      variables() {
        return {
          eventId: this.eventId,
          workshopId: this.workshopId,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          const {
            getWorkshop: { event, ...workshop },
            getHalls,
          } = data
          const { attendees, attending, lecturers, ...w } = workshop
          this.workshop = workshop
          this.form = {
            ...w,
            lecturers,
          }
          this.halls = getHalls
          this.attending = attending
          this.event = event
        }
      },
    },
  },
  methods: {
    async deleteWorkshop() {
      await deleteWorkshop(this.eventId, this.workshopId)
      this.goBack()
    },
    async submitForm() {
      await submitGuard(this, async () => {
        const { lecturers, ...values } = this.form
        const attendanceLimit = values.unlimitedAttendance ? 0 : values.attendanceLimit
        const data = { ...values, attendanceLimit }
        await updateWorkshop({
          eventId: this.eventId,
          workshopData: {
            id: this.workshopId,
            lecturerIds: lecturers.map(l => l.id),
            ...data,
          },
          refetchQueries: ['GetWorkshops'],
        })
        this.goBack()
      })
    },
  },
}
</script>

<style>
.form-container {
  margin-right: 30px;
}
.workshop-details {
  margin: 68px -30px 0 0;
}
@media (max-width: 800px) {
  .workshop-update-container {
    display: flex;
    flex-direction: column;
  }
  .form-container {
    margin-right: 0;
  }
  .email-shortcodes {
    margin: 32px 0;
  }
  .workshop-details {
    margin: 24px 0;
    width: 100%;
  }
}
</style>
